import React from 'react'
import PropTypes from 'prop-types'

import InstrumentNav from './InstrumentNav'
import '../stylesheets/instrumentView.scss'

const InstrumentView = props => {
  const { children } = props

  return (
    <div className='instrument-view page'>
      <InstrumentNav {...props} />
      {children}
    </div>
  )
}

InstrumentView.propTypes = {
  children: PropTypes.node,
}

export default InstrumentView
